export const compactCalendarClassNames = {
  months: "flex flex-col items-stretch",
  nav: "flex w-full items-center justify-between px-1 pt-1 pb-1",
  button_previous:
    "h-6 w-6 inline-flex items-center justify-center rounded-md bg-transparent p-0 text-gray-700 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent",
  button_next:
    "h-6 w-6 inline-flex items-center justify-center rounded-md bg-transparent p-0 text-gray-700 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent",
  chevron: "h-3.5 w-3.5",
  month: "space-y-2",
  month_caption: "flex justify-center pb-1 items-center",
  caption_label: "text-sm font-medium text-gray-900",
  month_grid: "w-full border-collapse",
  weekdays: "flex",
  weekday: "w-8 text-[0.7rem] font-medium text-gray-500 text-center",
  week: "flex w-full mt-1",
  day: "h-8 w-8 text-center text-xs p-0 relative",
  day_button:
    "h-8 w-8 rounded-md p-0 text-xs font-normal text-gray-900 hover:bg-gray-100 focus:bg-gray-100 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-transparent",
  selected:
    "[&>button]:bg-[var(--brand-primary)] [&>button]:text-[var(--brand-primary-text)] [&>button]:hover:bg-[var(--brand-primary)] [&>button]:font-medium",
  today: "[&>button]:ring-1 [&>button]:ring-inset [&>button]:ring-gray-300",
  outside: "text-gray-300",
  disabled: "text-gray-300 cursor-not-allowed",
};
